import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

export default function FullScreenLoadCircle() {
  return (
    <Box sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: 2,
        zIndex: 1000,
        backgroundColor: "rgba(255, 255, 255, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress size={96} />
    </Box>
  );
}
